import PropTypes from "prop-types";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { useTranslation } from "react-i18next";
import { EmptyFood } from "../empty-states/EmptyFood";
import { FoodItems } from "./FoodItems";

export const FoodDisplay = forwardRef(
  (
    {
      items,
      location,
      onRemoveItem,
      onUpdateItems,
      state,
      setState,
      recipeIngredients,
      recipeIngredientsSupported,
      onEditIngredients,
    },
    ref
  ) => {
    const { t } = useTranslation("athlete-portal");
    const { saveAsNewMeal, mealName, mealDescription } = state;
    const mealNameInputRef = useRef(null);

    //Send the method to the parent component
    useImperativeHandle(ref, () => ({
      focusMealName: () => {
        mealNameInputRef.current?.focus();
        mealNameInputRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      },
    }));

    /**
     * Handle the name and description of the meal
     * @param {*} e
     */
    const handleMealInputChange = (e) => {
      const { name, value } = e.target;

      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    return (
      <div className="display-food">
        {items.length > 0 ? (
          <>
            <FoodItems
              items={items}
              onRemoveItem={onRemoveItem}
              onUpdateItems={onUpdateItems}
              recipeIngredients={recipeIngredients}
              recipeIngredientsSupported={recipeIngredientsSupported}
              onEditIngredients={onEditIngredients}
            />
            {saveAsNewMeal && (
              <div className="save-new-meal">
                <div className="meal-name-container">
                  <label className="label" htmlFor="mealName">
                    {t("foodDisplay.mealName")}
                  </label>
                  <input
                    ref={mealNameInputRef}
                    maxLength={100}
                    type="text"
                    placeholder={t("foodDisplay.mealNamePlaceholder")}
                    name="mealName"
                    value={mealName}
                    onChange={handleMealInputChange}
                  />
                </div>
                <div>
                  <label className="label" htmlFor="mealDescription">
                    {t("foodDisplay.mealDescription")}
                  </label>
                  <input
                    type="text"
                    name="mealDescription"
                    placeholder={t("foodDisplay.mealDescriptionPlaceholder")}
                    value={mealDescription}
                    onChange={handleMealInputChange}
                    maxLength={100}
                  ></input>
                </div>
              </div>
            )}
          </>
        ) : (
          <EmptyFood label={location} variant="added" />
        )}
      </div>
    );
  }
);

FoodDisplay.propTypes = {
  items: PropTypes.array,
  location: PropTypes.string,
  onRemoveItem: PropTypes.func,
  onUpdateItems: PropTypes.func,
  state: PropTypes.object,
  setState: PropTypes.func,
  recipeIngredients: PropTypes.object,
  recipeIngredientsSupported: PropTypes.bool,
  onEditIngredients: PropTypes.func,
};
